import { Option } from '@types';
import { LangEnum } from '@enums';

export const langOptions: Option<LangEnum>[] = [
  {
    label: 'All languages',
    value: LangEnum.ALL,
  },
  {
    label: LangEnum.ENG.toUpperCase(),
    value: LangEnum.ENG,
  },
  {
    label: LangEnum.RU.toUpperCase(),
    value: LangEnum.RU,
  },
];
